




























import { defineComponent, onMounted, ref } from '@vue/composition-api'
export interface StyleMap {
  [key: string]: string
}
const types: StyleMap = {
  danger: 'bg-red-50 border border-red-300 ',
  info: 'bg-blue-50 border border-blue-300 ',
  warning: 'bg-yellow-50 border border-yellow-300',
  tip: 'border border-blue-300',
  success: 'bg-green-50 border border-green-300',
}

export default defineComponent({
  name: 'UIAlert',
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'danger',
    },
    closeable: {
      type: Boolean,
      default: false,
    },
    alertName: {
      type: String,
    },
    expireTime: {
      type: [String, Number],
      default: '1D',
    }
  },
  setup(props, ctx) {
    const theme = types[props.type]
    const closeAlert = ref(false);

    const close = () => {
      closeAlert.value = true;
      ctx.root.$cookie.set(props.alertName, true, { expires: props.expireTime })
    }

    onMounted(() => {
      closeAlert.value = ctx.root.$cookie.get(props.alertName) || false
    })

    return {
      theme,
      closeAlert,
      close,
    }
  },
})
